<div class="relative p-4 flex flex-col gap-4">
  <mat-card class="p-4 bg-[var(--main-card)]">
    <h6 class="font-semibold mb-4">Coordonnées de l'actionnaire</h6>
    <table class="w-full no-margin-field-bottom form-table">
      <tr>
        <td class="text-right whitespace-nowrap">Civilité</td>
        <td>
          <select-civilite
            [(ngModel)]="actionnaire.civilite_ID"
            [enableCreate]="true"
            [enableEdit]="true"
          ></select-civilite>
        </td>
      </tr>
      <tr>
        <td class="text-right whitespace-nowrap">Compte</td>
        <td>
          <mat-form-field appearance="outline" class="w-full">
            <input
              matInput
              [maxlengthinput]="12"
              [(ngModel)]="actionnaire.actionnaire_Code"
            />
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td class="text-right">Personne physique</td>
        <td>
          <mat-checkbox
            [(ngModel)]="actionnaire.actionnaire_Physique"
          ></mat-checkbox>
        </td>
      </tr>
      <tr>
        <td class="text-right">Sexe</td>
        <td>
          <mat-form-field appearance="outline" class="w-full">
            <mat-select [(ngModel)]="actionnaire.actionnaire_Sexe">
              <mat-option [value]="0">Masculin</mat-option>
              <mat-option [value]="1">Féminin</mat-option>
            </mat-select>
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td class="text-right">Groupe</td>
        <td>
          <select-groupe
            [(ngModel)]="actionnaire.groupe_ID"
            [selectNo]="true"
            [enableCreate]="true"
            [enableEdit]="true"
          ></select-groupe>
        </td>
      </tr>
      <tr>
        <td class="text-right">Nom</td>
        <td>
          <mat-form-field appearance="outline" class="w-full">
            <input
              matInput
              [maxlengthinput]="50"
              [(ngModel)]="actionnaire.actionnaire_Nom"
            />
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td class="text-right">Nom jeune fille</td>
        <td>
          <mat-form-field appearance="outline" class="w-full">
            <input
              matInput
              [maxlengthinput]="50"
              [(ngModel)]="actionnaire.actionnaire_NomJF"
            />
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td class="text-right">Prénom</td>
        <td>
          <mat-form-field appearance="outline" class="w-full">
            <input
              matInput
              [maxlengthinput]="50"
              [(ngModel)]="actionnaire.actionnaire_Prenom"
            />
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td class="text-right">Adresse</td>
        <td>
          <mat-form-field appearance="outline" class="w-full">
            <input
              matInput
              [maxlengthinput]="50"
              [(ngModel)]="actionnaire.actionnaire_Adresse1"
            />
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td class="text-right">Complément</td>
        <td>
          <mat-form-field appearance="outline" class="w-full">
            <input
              matInput
              [maxlengthinput]="50"
              [(ngModel)]="actionnaire.actionnaire_Adresse2"
            />
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td class="text-right">CP, Ville</td>
        <td class="flex gap-1">
          <mat-form-field appearance="outline" class="w-20">
            <input
              matInput
              [maxlengthinput]="6"
              [(ngModel)]="actionnaire.actionnaire_CP"
            />
          </mat-form-field>
          <mat-form-field appearance="outline" class="flex-1">
            <input
              matInput
              [maxlengthinput]="50"
              [(ngModel)]="actionnaire.actionnaire_Ville"
            />
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td class="text-right">Pays</td>
        <td>
          <select-pays
            [(ngModel)]="actionnaire.pays_ID"
            [selectNo]="true"
            [enableCreate]="true"
            [enableEdit]="true"
          ></select-pays>
        </td>
      </tr>
      <tr>
        <td class="text-right">Non résident</td>
        <td>
          <mat-checkbox
            [(ngModel)]="actionnaire.actionnaire_NonResident"
          ></mat-checkbox>
        </td>
      </tr>
      <tr>
        <td class="text-right">Date naissance</td>
        <td>
          <select-date
            [(value)]="actionnaire.actionnaire_DDN"
            title=""
          ></select-date>
        </td>
      </tr>
      <tr>
        <td class="text-right">Dép, commune naissance</td>
        <td class="flex items-center gap-1">
          <mat-form-field appearance="outline" class="w-20">
            <input
              matInput
              [maxlengthinput]="5"
              [(ngModel)]="actionnaire.actionnaire_DepNaiss"
            />
          </mat-form-field>
          <mat-form-field appearance="outline" class="flex-1">
            <input
              matInput
              [maxlengthinput]="50"
              [(ngModel)]="actionnaire.actionnaire_CommuneNaiss"
            />
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td class="text-right">SIRET</td>
        <td>
          <mat-form-field appearance="outline" class="w-full">
            <input
              matInput
              [maxlengthinput]="50"
              [(ngModel)]="actionnaire.actionnaire_Siret"
            />
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td class="text-right items-start">Décès</td>
        <td class="flex flex-col gap-1">
          <div class="flex items-center gap-1">
            <mat-checkbox
              [(ngModel)]="actionnaire.actionnaire_Mort"
            ></mat-checkbox>
            <select-date
              *ngIf="actionnaire.actionnaire_Mort"
              [(value)]="actionnaire.actionnaire_DecesLe"
              title="Le"
              class="flex-1"
            ></select-date>
          </div>
          <mat-form-field
            *ngIf="actionnaire.actionnaire_Mort"
            appearance="outline"
            class="w-full"
          >
            <mat-label>Instructions</mat-label>
            <input
              matInput
              [maxlengthinput]="50"
              [(ngModel)]="actionnaire.actionnaire_DecesNotes"
            />
          </mat-form-field>
        </td>
      </tr>
    </table>
  </mat-card>

  <mat-card class="p-4 bg-[var(--main-card)]">
    <h6 class="font-semibold mb-4">Communications de l'actionnaire</h6>
    <table class="w-full no-margin-field-bottom form-table">
      <tr>
        <td class="text-right items-start">Téléphones</td>
        <td class="flex items-center gap-1">
          <mat-form-field appearance="outline" class="flex-1">
            <input
              matInput
              [maxlengthinput]="20"
              [(ngModel)]="actionnaire.actionnaire_Tel1"
            />
          </mat-form-field>
          <mat-form-field appearance="outline" class="flex-1">
            <input
              matInput
              [maxlengthinput]="20"
              [(ngModel)]="actionnaire.actionnaire_Tel2"
            />
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td class="text-right items-start">Fax, Mobile</td>
        <td class="flex items-center gap-1">
          <mat-form-field appearance="outline" class="flex-1">
            <input
              matInput
              [maxlengthinput]="20"
              [(ngModel)]="actionnaire.actionnaire_Fax"
            />
          </mat-form-field>
          <mat-form-field appearance="outline" class="flex-1">
            <input
              matInput
              [maxlengthinput]="20"
              [(ngModel)]="actionnaire.actionnaire_Mobile"
            />
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td class="text-right whitespace-nowrap">Email</td>
        <td>
          <mat-form-field appearance="outline" class="w-full">
            <input
              matInput
              [maxlengthinput]="50"
              [(ngModel)]="actionnaire.actionnaire_Email"
            />
          </mat-form-field>
        </td>
      </tr>
    </table>
  </mat-card>

  <mat-card class="p-4 bg-[var(--main-card)]">
    <h6 class="font-semibold mb-4">Compte administré</h6>
    <table class="w-full no-margin-field-bottom form-table">
      <tr>
        <td class="text-right">Compte administré</td>
        <td>
          <mat-checkbox
            [(ngModel)]="actionnaire.actionnaire_Administre"
            (change)="onAdministreChange($event)"
          ></mat-checkbox>
        </td>
      </tr>
      <tr *ngIf="actionnaire.actionnaire_Administre">
        <td class="text-right whitespace-nowrap">Administrateur</td>
        <td>
          <select-administre
            [(ngModel)]="actionnaire.administre_ID"
            [selectNo]="true"
            [enableCreate]="true"
            [enableEdit]="true"
          ></select-administre>
        </td>
      </tr>
    </table>
  </mat-card>
</div>
